import { render } from "./dashboardModules.vue?vue&type=template&id=43e05d04&scoped=true"
import script from "./dashboardModules.vue?vue&type=script&lang=js"
export * from "./dashboardModules.vue?vue&type=script&lang=js"

import "./dashboardModules.vue?vue&type=style&index=0&id=43e05d04&scoped=true&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e05d04"]])

export default __exports__